module.exports = __webpack_public_path__ + "media/images/home/flow_r_3-dfb434aac2add5eb40c4a3c99ea8fa40.svg";